import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import Header from "../header";
import Footer from "../footer";
import moment from "moment";
import { listcompbook } from "../../service/dashboard";

const ComplaintList = () => {
    const [fromdate, setFromDate] = useState("");
    const [todate, setToDate] = useState("");
    const [leaveData, setLeaveData] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {

        const currentDate = new Date();
        const firstDay = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            1
        );
        listall(
            moment(firstDay).format("YYYY-MM-DD"),
            moment(new Date()).format("YYYY-MM-DD")
        );
    }, []);
    function listall(fdate, tdate) {
        setFromDate(fdate);
        setToDate(tdate);
        const temp = new FormData();
        temp.append("from_date", fdate);
        temp.append("to_date", tdate);
        temp.append("status", 1);
        listcompbook(temp).then((res) => {
            if (res.status === true) {

                const cdata = res.data.details.filter((item) => item.created_by == localStorage.getItem("UID"));
                if (cdata.length > 0) {
                    const ddata = cdata.map((item) => {
                        return {
                            ...item,
                            complaint_date: moment(item.complaint_date).format("DD-MM-YYYY"),
                        }
                    });
                    setLeaveData(ddata);
                }
            }
        });
    }

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />
                <div className="moreheading">
                    <Row className="row-sm">

                        <Col xs={2} className="text-left align-self-end">
                            <h4 className="morehead-text">Complaint</h4>
                        </Col>

                        <Col xs={10} className="text-right align-self-end">
                            <Link to={"/addcomplaint"} className="btn-outline-success green-btn btn-sm">
                                Add Complaint
                            </Link>
                            <Link to={"/dashboard"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>

                    </Row>
                </div>

                <div className="leave-container">
                    <div className="row">
                        {/* <h4 className="subhead-text">Complaint List</h4> */}

                        <div className="col-lg-3 col-md-3">
                            <div className="formapply">

                                <label className="form-label fw-bold">From Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={fromdate}
                                    onChange={(e) => listall(e.target.value, todate)}
                                />
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-3">
                            <div className="formapply">

                                <label className="form-label fw-bold">To Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={todate}
                                    onChange={(e) => listall(fromdate, e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    {leaveData.length > 0 ? (
                        leaveData.map((leave, index) => (
                            <div className="leave-card mt-2" key={index}>
                                <div><strong>Name:</strong> {leave.complaint_name}</div>
                                <div><strong>Date:</strong> {leave.complaint_date}</div>
                                <div><strong>Phone:</strong> {leave.phone}</div>
                                <div><strong>Priority:</strong> {leave.priority}</div>
                                <div><strong>Reason:</strong> {leave.complaint_reason}</div>

                            </div>
                        ))
                    ) : (
                        <div className="leave-card mt-2 text-center">
                            <div><strong>No Data Found</strong></div>
                        </div>
                    )}

                </div>
            </div>

            <Footer />
        </div>
    );
};

export default ComplaintList;
